import React from "react";
import { UserContextInterface } from "types/user";

export const UserContext = React.createContext<UserContextInterface>({
  setUser: (_userId: string) => {},
  logout: async () => {},
  currentUserId: null,
});
